/** Мок API: лига и друзья. */
import type { FakeDb, FakeHandlers } from "./db";

export function leagueHandlers(db: FakeDb): FakeHandlers<"league" | "claimLeague" | "friends"> {
  return {
    league: async () => ({ tier: 0, endsAt: Date.now(), group: null, last: null, unclaimed: 0 }),
    claimLeague: async () => ({ crystals: 0, state: db.fresh() }),
    friends: async () => ({ rows: [], inviteUrl: null, reward: null }),
  };
}
